module.exports = __webpack_public_path__ + "static-portal/img/new8-1.20aab49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new8-1.png
// module id = mZvb
// module chunks = 4